export enum AssistantChatMenuType {
    NewChat = 'NewChat',
    PreviousChats = 'PreviousChats',
    GoBack = 'GoBack',
}
